import ng from "angular";
//import ngSanitize from 'angular-sanitize';
//import ngTouch from 'angular-touch';
//import ngInfiniteScroll from 'ng-infinite-scroll';
//import uiBootstrap from 'angular-ui-bootstrap';
//import uiMask from 'angular-ui-mask';
import uiRouter from "angular-ui-router";
import ngStorage from "ngstorage";
import ngFileUpload from "ng-file-upload";

export const MODULE_NAME = "emun";
export const angular = ng;
export const $ = angular.element;

//#region $injector
export const $injector = angular.injector(["ng", ngStorage.name, ngFileUpload]); //, 'ngStorage','ui.bootstrap','ui.router'
export const $doc = $(document);
export const $q = $injector.get("$q");
export const $window = $injector.get("$window");
export const $rootScope = $injector.get("$rootScope");
export const $timeout = $injector.get("$timeout");
export const $interval = $injector.get("$interval");
export const $parse = $injector.get("$parse");
export const $http = $injector.get("$http");
export const $sce = $injector.get("$sce");
export const $interpolate = $injector.get("$interpolate");
//export const $location = $injector.get('$location');
export const $filter = $injector.get("$filter");
export const $log = $injector.get("$log");
export const $animate = $injector.get("$animate");
export const $compile = $injector.get("$compile");

//ngStorage
export const $localStorage = $injector.get("$localStorage");
export const $sessionStorage = $injector.get("$sessionStorage");

//#endregion $injector

export const RE_SANITIZE =
  /^\s*(https?|ss|ftp|mailto|tel|file|sms|javascript|chrome-extension):/;
const iocContainer = {};
export const resolve = (name) => {
  if (iocContainer[name]) return iocContainer[name];
  const $di = $doc.injector();
  if ($di) return (iocContainer[name] = $di.get(name));
  return $injector.get(name);
};

const seed = {
  dependencies: [ngStorage.name, ngFileUpload, uiRouter],
  values: {},
  components: {},
  directives: {},
  filters: {},
  states: {},
  runners: {},
  factories: {
    // modals: () => null, //PLUGIN ONLY
    // $cart: () => null,
    // $notify: () => null
  },
  services: {},
};

const reducer = (memo, mod) => {
  const {
    dependencies = [],
    modules = {},
    components = {},
    directives = {},
    filters = {},
    states = {},
    runners = {},
    factories = {},
    services = {},
    values = {},
  } = mod;

  return {
    dependencies: [...memo.dependencies, ...dependencies],
    modules: Object.assign({}, memo.modules, modules),
    components: Object.assign({}, memo.components, components),
    directives: Object.assign({}, memo.directives, directives),
    filters: Object.assign({}, memo.filters, filters),
    states: Object.assign({}, memo.states, states),
    runners: Object.assign({}, memo.runners, runners),
    factories: Object.assign({}, memo.factories, factories),
    services: Object.assign({}, memo.services, services),
    values: Object.assign({}, memo.values, values),
  };
};

export const createModule = (moduleName, ...modules) => {
  const mod = modules.reduce(reducer, seed);
  const app = angular.module(moduleName, mod.dependencies);
  extendModule(app, mod);
  return app;
};

export const extendModule = (app, ...modules) => {
  const {
    dependencies = [],
    modules: dependentModules = {},
    components = {},
    directives = {},
    filters = {},
    states = {},
    runners = {},
    factories = {},
    services = {},
    config = {},
    values = {},
  } = modules.reduce(reducer, seed);

  for (const name in dependentModules) {
    extendModule(app, dependentModules[name]);
  }
  for (const name in values) {
    app.factory(name, values[name]);
  }
  for (const name in components) {
    app.component(name, components[name]);
  }
  for (const name in directives) {
    app.directive(name, directives[name]);
  }
  for (const name in filters) {
    app.filter(name, filters[name]);
  }
  for (const name in services) {
    app.service(name, services[name]);
  }
  for (const name in factories) {
    app.factory(name, factories[name]);
  }

  if (Object.keys(states).length) {
    app.config(($stateProvider, $compileProvider) => {
      //$locationProvider.hashPrefix('');
      // $locationProvider.html5Mode(true);

      for (const name in states) {
        const so = $stateProvider.state({ name, ...states[name] });
      }
      $compileProvider.aHrefSanitizationWhitelist(RE_SANITIZE);
      $compileProvider.imgSrcSanitizationWhitelist(RE_SANITIZE);
    });
  }

  for (const name in config) {
    app.config(config[name]);
    //console.debug("config", name);
  }

  for (const name in runners) {
    app.run(runners[name]);
    //console.debug("runner", name);
  }

  return app;
};

export const createDataProvider = (name, options) => ($parse) => {
  return Object.assign(
    {
      restrict: "E",
      scope: true,
      controllerAs: "$ctrl",
      link(scope, element, attrs, ctrl) {
        const providerId = attrs.ngModel || attrs.providerId || attrs.id;
        if (providerId) {
          $parse(providerId).assign(scope.$parent, ctrl);
        }
        if (name) {
          $parse("$" + name).assign(scope, ctrl);
        }
      },
    },
    options
  );
};

export const createDependent = (parentName, template) => () => ({
  require: "^" + parentName,
  scope: true,
  template,
  link(scope, element, attrs, ctrl) {
    scope.$ctrl = ctrl;
    scope["$" + parentName] = ctrl;
  },
});

export const bootstrap = (...modules) => {
  const app = createModule(MODULE_NAME, ...modules);

  $doc.ready(() =>
    angular.bootstrap(document, [app.name, ngStorage.name, uiRouter, "tmpls"])
  );
  return app;
};

export default resolve;
